export default __webpack_public_path__ + "static/img/homepage-foreground.124de5e.png";